import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { CustomFormControl, CustomFormSelect } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';
import { Options } from '../SelectOptions';
import { parse } from 'date-fns/parse'
import { isDate } from 'date-fns/fp'
export const characterRestrictionRegExp = /^[a-zA-Z0-9äöüÄÖÜßé '.,!?&_/\-()]+$/i;

function parseDateString(value, originalValue) {
    const parsedDate = isDate(originalValue) || originalValue == null
        ? originalValue
        : parse(originalValue, "yyyy-MM-dd", new Date());

    return parsedDate;
}
const today = new Date();

export const Schema = Yup.object().shape({
    salutation: Yup.string().required("Angabe ist erforderlich"),
});

export const PersonalDataSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
            <Form.Group  className="mb-3" controlId="formSalutation">
                    <Form.Label>Anrede*</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="salutation"
                        value={values.salutation}
                        isValid={touched.salutation && !errors.salutation}
                        isInvalid={touched.salutation && errors.salutation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.Salutation.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.salutation}
                    </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};